import Stack from '@mui/material/Stack'
import React from 'react'

const MoovyTableControlLayout = (props: {
  searchControl: React.ReactNode
  sortControl: React.ReactNode
}) => {
  return (
    <Stack
      marginTop={2}
      padding={1}
      direction="column"
      spacing={2}
      justifyContent="space-between"
      alignItems="flex-start"
      width="100%"
    >
      {props.searchControl}
      <Stack
        direction="row"
        spacing={1}
        justifyContent="flex-end"
        alignItems="center"
      >
        {props.sortControl}
      </Stack>
    </Stack>
  )
}

export default MoovyTableControlLayout
